import { EditIcon, Paragraph } from '@quickmd-llc/design-system';
import { Question, QuestionType } from '@qmd-types/intakeForms';
import { ConditionReviewSection } from './ConditionReviewSection';
import { BodyMeasurementReviewSection } from './BodyMeasurementReviewSection';
import { useIntakeForm } from '../../context/useIntakeForm';
import { formatAddress } from 'utils/misc/formatAddress';

type Props = { onEdit: (question: Question) => void; question: Question };

export function ReviewSection({ onEdit, question }: Props) {
  const { isIntakeFormComplete } = useIntakeForm();
  const { question: questionText, type } = question;

  if (type === QuestionType.BODY_MEASUREMENT) {
    return <BodyMeasurementReviewSection onEdit={onEdit} question={question} />;
  }

  if (type === QuestionType.CONDITION) {
    return <ConditionReviewSection onEdit={onEdit} question={question} />;
  }

  const answerText = getAnswerFromQuestion(question) || '--';
  const showEditIcon = !isIntakeFormComplete && type !== QuestionType.STATEMENT;

  return (
    <div className="grid gap-0.5">
      <div className="flex items-center justify-between gap-4">
        <Paragraph className="font-semibold text-text-dark">
          {questionText}
        </Paragraph>
        {showEditIcon && (
          <EditIcon
            className="cursor-pointer text-text-dark"
            iconSize="l"
            onClick={() => onEdit(question)}
          />
        )}
      </div>

      <Paragraph>{answerText}</Paragraph>
    </div>
  );
}

function getAnswerFromQuestion(question: Question): string | null {
  switch (question.type) {
    case QuestionType.EMAIL:
      return question.email;
    case QuestionType.OPTION:
      return question.options
        .filter((option) => option.isSelected)
        .map((option) => option.name)
        .join(', ');
    case QuestionType.STATEMENT:
      return null;
    case QuestionType.TEXTBOX:
      return question.text;
    case QuestionType.PHARMACY_SELECTION:
      return question.pharmacyId
        ? `${question.name} - ${formatAddress(question.address)}`
        : null;
    default:
      return null;
  }
}
